import { types } from "mobx-state-tree";

const GenericJSONPrimitive = types.custom({
  name: "GenericJSON",
  fromSnapshot(value) {
    return value;
  },
  toSnapshot(value) {
    return value;
  },
  isTargetType(value) {
    return value instanceof Array || value instanceof Map;
  },
  getValidationMessage(value) {
    try {
      // Check for undefined and valid parsed JSON
      if (
        value === undefined ||
        value instanceof Array ||
        value instanceof Object
      ) {
        return "";
      }
      // Checks for valid JSON string (block null from passing)
      return JSON.parse(value) && !!value
        ? ""
        : `Null check error: ${value} doesn't look like a valid JSON primitive`;
    } catch (e) {
      return `JSON parse error: ${value} doesn't look like a valid JSON primitive`;
    }
  }
});

export default GenericJSONPrimitive;
